import { FontDto } from '../api/dtos';
import {
    isFont,
    isFontWeight,
    OnlinePagesFontTypeEnum,
    OnlinePagesFontWeightEnum
} from './types';

interface ValidFont {
    type: OnlinePagesFontTypeEnum;
    weight: OnlinePagesFontWeightEnum;
}

export const isValidFont = (font?: FontDto): font is ValidFont =>
    Boolean(font?.type) &&
    isFont(font?.type) &&
    Boolean(font?.weight) &&
    isFontWeight(font?.weight);
